// يحوّل صفوف الحضور الخام إلى نقاط يومية + إجماليات ونِسَب للرسم التفاعلي.
export const buildTrend = (rows) => {
  const byDate = rows.reduce((acc, r) => {
    acc[r.date] = acc[r.date] || { date: r.date, present: 0, late: 0, absent: 0 };
    if (r.check_out_at) {
      acc[r.date].present += 1;
      if (r.late_minutes > 0) acc[r.date].late += 1;
    } else {
      acc[r.date].absent += 1;
    }
    return acc;
  }, {});

  const data = Object.values(byDate)
    .sort((a, b) => a.date.localeCompare(b.date))
    .map((d) => {
      const total = d.present + d.absent;
      return { ...d, label: d.date.slice(5), rate: total ? Math.round((d.present / total) * 100) : 0 };
    });

  const days = data.length || 1;
  const totals = data.reduce(
    (acc, d) => ({
      present: acc.present + d.present,
      late: acc.late + d.late,
      absent: acc.absent + d.absent,
      rate: acc.rate + d.rate,
    }),
    { present: 0, late: 0, absent: 0, rate: 0 },
  );

  return { data, totals: { ...totals, rate: Math.round(totals.rate / days) } };
};
